import { useMemo } from 'react'

import type { ApiClient } from 'clients/yogi-api'
import { useApiClient } from 'clients/yogi-api'

export type FeatureFlagsResponse = {
  [key: string]: boolean
}

class FeatureFlagsService {
  constructor(private client: ApiClient) {}

  getFeatureFlags(proj_uuid: string): Promise<FeatureFlagsResponse> {
    return this.client
      .get<FeatureFlagsResponse>('/feature_flags', {
        params: { proj_uuid },
      })
      .then(({ data }) => data)
  }
}

export function useFeatureFlagsService(): FeatureFlagsService {
  const client = useApiClient()
  return useMemo(() => new FeatureFlagsService(client), [client])
}
